import { takeLatest, put, call, select } from 'redux-saga/effects';
import { find, get, merge, map } from 'lodash';
import { getSeasonWithProductionsAction, getSeasonsProductionAction } from './actions';
import { getListSaga } from '../App/saga';
import { selectSeasonCompaniesList } from './selectors';
import * as API from '../../utils/API';

export function* getSeasonCompaniesByCountrySlugSaga({ payload }) {
  const { sagaRoutine, countrySlug } = payload;
  if (sagaRoutine === null) {
    throw new Error('Specify sagaRoutine');
  }
  try {
    const countries = yield call(API.getCountries, null, { slug: countrySlug });
    const selectedCountry = find(get(countries, 'data.data', []), country => get(country, 'slug') === countrySlug);
    const payloadWithCountry = merge(payload, { params: { queryParams: { country_id: get(selectedCountry, 'id') } } });
    yield call(getListSaga, { payload: payloadWithCountry });
  } catch (err) {
    yield put(sagaRoutine.failure(err.message));
  }
}

export function* getSeasonWithProductionsSaga({ payload }) {
  const { params } = payload;
  yield call(getListSaga, { payload });
  const seasons = yield select(selectSeasonCompaniesList());
  let ids = map(seasons?.data || [], company => get(company, 'id'));
  ids = ids.filter(Boolean);
  const season_id = get(params, 'queryParams.season_id');
  const responseProductions = yield call(API.getProductions, {
    limit: 1000,
    season_id,
    approved_by: 'admin, company',
    company_id: ids.join(','),
    distinct: 'company_id',
    sort: '-year',
  });
  try {
    yield put(getSeasonsProductionAction.success(get(responseProductions, 'data')));
  } catch (err) {
    yield put(getSeasonsProductionAction.failure(err.message));
  } finally {
    yield put(getSeasonsProductionAction.fulfill());
  }
}

export default function* seasonsSaga() {
  yield takeLatest(getSeasonWithProductionsAction.TRIGGER, getSeasonWithProductionsSaga);
  // yield takeLatest(getSeasonCompaniesByCountrySlugAction.TRIGGER, getSeasonCompaniesByCountrySlugSaga);
}
